<div class="row">
  <div class="col-md-12 section-header">
    {{ 'bikeshop.rentals.configuration.custom_pickup_slots' | translate }}
  </div>
</div>

<div class="info" *ngIf="!loadingPickupSlots && pickupSlots.length === 0">
  {{'bikeshop.rentals.configuration.custom_pickup_slots_info' | translate}}</div>

<div class="loader" *ngIf="deleting"></div>

<table class="data margin-top-16" *ngIf="pickupSlots.length > 0">
  <tr>
    <th>{{'bikeshop.calendar.day' | translate}}</th>
    <th>{{'bikeshop.rentals.booking.pickup_time' | translate}}</th>
    <th>
      <span *ngIf="canAddOverrideSlots()" class="hubtiger-add pull-right" (click)="addNew()"></span>
    </th>
  </tr>
  <tbody>
  <tr *ngFor="let item of pickupSlots;let i = index;">
    <td>{{dayOfWeek(item.dayOfWeek)}}</td>
    <td>
      {{'1970-01-01 ' + item.pickupTime | date : "h:mm a"}}
    </td>
    <td>
      <span class="fa hubtiger-edit" (click)="editRecord(item)"></span>
      <span class="fa hubtiger-delete" (click)="deleteRecord(item, i)"></span>
    </td>
  </tr>
  </tbody>
</table>

<div *ngIf="!loadingPickupSlots && pickupSlots.length === 0  && canAddOverrideSlots()"
     class="margin-top-16 create-new">
  <button pButton type="button" class="p-button-raised full-width accent"
          label="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}" (click)="addNew()"></button>
</div>

<p-sidebar #NavSideBar [(visible)]="showCustomPickupSlot" position="right"
           [style]="{width:'40em', background: '#F6F6F8', 'overflow-x': 'auto'}"
           (onHide)="getOverridePickupSlots(); NavSideBar.destroyModal()">
  <div *ngIf="showCustomPickupSlot">
    <app-add-edit-rental-custom-pickup-slot [data]="panelData" [configuration]="configuration"
                                            (close)="closePanel($event)">
    </app-add-edit-rental-custom-pickup-slot>
  </div>
</p-sidebar>
